// Logger utility to persist logs across page navigations
class Logger {
  private static instance: Logger;
  private logs: any[] = [];
  private readonly MAX_LOGS = 100;

  private constructor() {
    // Initialize logs from sessionStorage if available
    const storedLogs = sessionStorage.getItem('app_logs');
    if (storedLogs) {
      this.logs = JSON.parse(storedLogs);
    }

    // Override console methods
    this.overrideConsole();
  }

  static getInstance(): Logger {
    if (!Logger.instance) {
      Logger.instance = new Logger();
    }
    return Logger.instance;
  }

  private overrideConsole() {
    const originalConsole = {
      log: console.log,
      error: console.error,
      warn: console.warn,
      info: console.info
    };

    // Override console methods
    console.log = (...args) => {
      this.addLog('log', args);
      originalConsole.log.apply(console, args);
    };

    console.error = (...args) => {
      this.addLog('error', args);
      originalConsole.error.apply(console, args);
    };

    console.warn = (...args) => {
      this.addLog('warn', args);
      originalConsole.warn.apply(console, args);
    };

    console.info = (...args) => {
      this.addLog('info', args);
      originalConsole.info.apply(console, args);
    };
  }

  private addLog(type: string, args: any[]) {
    try {
      const logEntry = {
        timestamp: new Date().toISOString(),
        type,
        data: args.map(arg => {
          if (arg instanceof Error) {
            return {
              message: arg.message,
              stack: arg.stack,
              name: arg.name
            };
          }
          return arg;
        }),
        url: window.location.href
      };

      this.logs.unshift(logEntry);
      
      // Keep only the last MAX_LOGS entries
      if (this.logs.length > this.MAX_LOGS) {
        this.logs = this.logs.slice(0, this.MAX_LOGS);
      }

      // Store in sessionStorage
      try {
        sessionStorage.setItem('app_logs', JSON.stringify(this.logs));
      } catch (e) {
        console.warn('Failed to store logs in sessionStorage:', e);
      }
    } catch (e) {
      console.warn('Failed to add log entry:', e);
    }
  }

  getLogs() {
    try {
      return this.logs;
    } catch (e) {
      console.warn('Failed to get logs:', e);
      return [];
    }
  }

  clearLogs() {
    try {
      this.logs = [];
      sessionStorage.removeItem('app_logs');
    } catch (e) {
      console.warn('Failed to clear logs:', e);
    }
  }
}

export const logger = Logger.getInstance(); 